import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";
const API_BASE = getApiBaseUrl();

export const getDashboardGraph = async (token: string) => {
  return await apiFetch<DashboardGraph>(`${API_BASE}/api/management/dashboard/graph`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getDashboardSummaryStats = async (token: string) => {
  return await apiFetch<DashboardSummary>(`${API_BASE}/api/management/dashboard/summary-stats`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getDashboardJapanMap = async (token: string) => {
  return await apiFetch<PrefectureCompletionResult>(`${API_BASE}/api/management/dashboard/japan-map`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getDashboardAiComment = async (token: string, comment_type: number ) => {
  return await apiFetch<AiCommentInfo>(`${API_BASE}/api/management/dashboard/ai-comment`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ comment_type }),
  });
};

export async function saveDashboardAiComment(
  token: string,
  id: number,
  thumb_up: boolean,
  thumb_down: boolean
): Promise<AiCommentInfo> {
  return await apiFetch(`${API_BASE}/api/management/dashboard/ai-comment`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: id, thumb_up: thumb_up, thumb_down: thumb_down }),
  });
}

export interface DashboardGraph {
  report_data: {
    labels: string[];
    data: number[];
  };
}

export interface DashboardSummary {
  total_completed_tasks: number;
  total_pomodoro_sessions: number;
  monthly_login_days: number;
  overdue_tasks: number;
}

export interface CompletedPrefecture {
  id: number;
  name_ja: string;
  name_en: string;
}

export interface PrefectureCompletionResult {
  in_progress_prefectures: CompletedPrefecture[];
  completed_count: number;
  completed_prefectures: CompletedPrefecture[];
}

export interface AiCommentInfo {
  id: number | null;
  comment_type: number;
  ai_comment_title: string;
  ai_comment_comment: string;
  ai_comment_thumb_up: boolean;
  ai_comment_thumb_down: boolean;
}
